<template>
  <div :class="variant">
    <div class="px-2">
      <div v-if="!(!hasDreOffersSchedulesResults && isHomeVariant)" class="data-values">
        <div v-if="!isHomeVariant" class="data-title">
          <span>{{ analysedPeriod }}</span>
        </div>
        <div class="increment" :class="isHomeVariant ? 'use-column' : 'use-row'">
          <span>Incremento total</span>
          <span>R$ {{ showMockData ? 'XXX.XXX' : increment }} </span>
        </div>
        <div class="discount" :class="isHomeVariant ? 'use-column' : 'use-row'">
          <span>Desconto total</span>
          <span>R$ {{ showMockData ? 'XXX.XXX' : discount }}</span>
        </div>
      </div>
      <div :class="{ 'incremental-revenue-blur': !hasDreOffersSchedulesResults && isHomeVariant }">
        <div class="data-line"></div>
        <div class="data-incremental-revenue" :class="isHomeVariant ? 'use-column' : 'use-row'">
          <span>Fat. Incremental</span>
          <span class="incremental-revenue-value">R$ {{ showMockData ? 'XXX.XXX' : incrementalRevenue }} </span>
        </div>
      </div>
    </div>

    <mf-button
      v-if="isHomeVariant"
      label="Ver mais detalhes"
      icon="arrow_forward"
      icon-position="right"
      color="marca-0-l40"
      class="mt-3"
      text
      @click="$emit('go-to-dre')"
    />
  </div>
</template>

<script>
import { localeString } from '@/config/helpers.js'
import { mapGetters } from 'vuex'
import { DateTime } from 'luxon'

export default {
  name: 'IncrementalRevenueChartMetrics',
  props: {
    variant: {
      type: String,
      default: 'dre',
      validator: (value) => ['', 'dre', 'home'].includes(value),
    },
    showMockData: {
      type: Boolean,
      default: false,
    },
    formattedDateLabel: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters(['dreRevenueIncrementMetrics', 'dreAnalysedPeriod', 'hasDreOffersSchedulesResults']),
    metrics() {
      return this.dreRevenueIncrementMetrics?.generalMetrics
    },
    increment() {
      return this.metrics?.increment ? localeString(this.metrics.increment, 0) : 0
    },
    discount() {
      return this.metrics?.discount ? localeString(this.metrics.discount, 0) : 0
    },
    incrementalRevenue() {
      return this.metrics?.incrementalRevenue ? localeString(this.metrics.incrementalRevenue, 0) : 0
    },
    isHomeVariant() {
      return ['home'].includes(this.variant)
    },
    analysedPeriod() {
      if (this.formattedDateLabel) return this.formattedDateLabel
      const period = DateTime.fromFormat(this.dreAnalysedPeriod, 'yyyy-MM').toFormat("MMMM 'de' yyyy")
      return period[0].toUpperCase() + period.substring(1)
    },
  },
}
</script>

<style lang="scss" scoped>
.data-values {
  display: flex;
  flex-direction: column;
  gap: 20px;
  .increment,
  .discount {
    display: flex;

    :first-child {
      font-weight: 400;
      line-height: 120%;
      letter-spacing: 0.4px;
    }
    :nth-child(2) {
      font-weight: 700;
      line-height: 120%;
    }
  }
  .increment {
    :nth-child(2) {
      color: $verde-d20;
    }
  }
  .discount {
    :nth-child(2) {
      color: $vermelho-d20;
    }
  }
}
.incremental-revenue-blur {
  opacity: 0.4;
}
.data-line {
  border-bottom: 1px solid $cinza-l60;
  margin: 12px 0;
}
.data-incremental-revenue {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  :first-child {
    font-size: 16px;
    font-weight: 400;
    line-height: 200%;
    letter-spacing: 0.4px;
  }
  .incremental-revenue-value {
    background-color: #e7faee;
    color: $verde-d20;
    font-weight: 700;
    line-height: 120%;
    border-radius: 8px;
  }
}

.dre {
  min-width: 290px;
  .data-title {
    color: $cinza-d10;
    font-weight: 400;
    line-height: 120%;
    letter-spacing: 0.22px;
    font-size: 22px;
    margin-bottom: 32px;
  }

  .data-values {
    .increment,
    .discount {
      :first-child {
        font-size: 16px;
        color: $cinza-0;
      }
      :nth-child(2) {
        font-size: 18px;
      }
    }
  }

  .data-incremental-revenue {
    :first-child {
      font-size: 16px;
      color: $cinza-0;
    }
    .incremental-revenue-value {
      padding: 6px 12px;
      font-size: 18px;
    }
  }
}

.home {
  min-width: 166px;

  .data-values {
    gap: 12px;
    .increment,
    .discount {
      flex-direction: column;
      :first-child {
        font-size: 14px;
      }
      :nth-child(2) {
        font-size: 16px;
      }
    }
    .increment {
      :first-child {
        color: $verde-d20;
      }
    }
    .discount {
      :first-child {
        color: $vermelho-d20;
      }
    }
  }

  .data-incremental-revenue {
    flex-direction: column;
    align-items: flex-start;
    :first-child {
      color: $verde-d20;
      font-size: 14px;
    }
    .incremental-revenue-value {
      display: inline-block;
      padding: 4px 8px;
      font-size: 16px;
      border-radius: 8px;
    }
  }
}

.use-column {
  flex-direction: column;
}
.use-row {
  flex-direction: row;
  justify-content: space-between;
}
</style>
